import { render, staticRenderFns } from "./ReservaComponent.vue?vue&type=template&id=559cdf9e"
import script from "./ReservaComponent.vue?vue&type=script&lang=js"
export * from "./ReservaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports